'use strict';

var Dispatcher = require('flux').Dispatcher;

module.exports = new Dispatcher();


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./core/AppDispatcher.jsx